import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { RouterService } from 'core/services/router.service';
import { StorageService } from 'core/services/storage.service';
import { AlertService } from 'core/services/alert.service';
import { PERMISSIONS } from 'shared/enums/permissions.enum';
import { TranslationService } from 'core/services/translation.service';

export const AuthGuard: CanActivateFn = (route) => {
  const storageService = inject(StorageService);
  const routerService = inject(RouterService);
  const alertService = inject(AlertService);
  const translationService = inject(TranslationService);

  const { isAuthenticated } = storageService;

  if (!isAuthenticated) {
    storageService.clearStorage();
    routerService.goToLogin();
    return false;
  } else if (!isBaseRoute()) {
    const permissions = route.data['permissions'] as PERMISSIONS[];
    const hasPermission = permissions.some(p => storageService.hasPermission(p));
    if (!hasPermission) {
      alertService.errorToaster(translationService.getTranslation('youAreNotPermitToAccessThisFeature'));
    }

    return hasPermission;
  }

  return true;
};

const isBaseRoute = (): boolean => {
  return window.location.pathname === '/'
}